import React from "react";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import { getImageUrl } from "../../../../../utils/imageUtils";
import style from "../../../Blog/Blog.module.css";

export const MultipleSlider = ({ articles }) => {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className={style.carouselContainer}>
      <Slider {...settings}>
        {articles.map((article, index) => (
          <div key={article.id || article._id || index} className={style.cards}>
            <div className={style.cardInnerUltimosArticulos}>
              <div className={style.contenedorTitulo}>
                <h4 className={style.tituloCards}>{article.title}</h4>
              </div>
              <div className={style.contenedorImg}>
                <img
                  className={style.imagen}
                  src={getImageUrl(article.image, 'medium')}
                  alt={`Imagen ilustrativa del producto ${article.title}`}
                />
              </div>
              <div className={style.contenedorDescripcion}>
                <p className={style.descripcionUltimosArticulos}>{article.description}</p>
              </div>

              <Link
                onClick={handleScrollToTop}
                to={"/detalle-blog"}
                state={{ article }}
                className={style.contenedorBtn}
              >
                Leer más
              </Link>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};
